import axios from "axios";

export const retrieve = async (u) => {
  return await axios.get(u);
};

export const send = async (u, d) => {
  return await axios.post(u, d);
};
